module.exports = __webpack_public_path__ + "img/auto_grid_mob.807af542.svg";